import React from 'react';
import classNames from 'clsx';
import { Checkbox, FormControlLabel } from '@material-ui/core';

import { CompareCepikDataEnum, FieldsEnum } from 'app/shared/enums';
import { CepikFormRowContainerProps } from './CepikFormRowContainer.interface';
import { useStyles } from './CepikFormRowContainer.styles';
import {
  fieldsWithoutConfirmationLabel,
  useCepikFormRowContainer,
} from './useCepikFormRowContainer';
import {
  cepikConfirmationLabelClassName,
  DefaultFormRowContainer,
} from 'app/components/DefaultFormRowContainer';

export default function CepikFormRowContainer(
  props: CepikFormRowContainerProps
) {
  const { children, className, formName, noPadding, ...restProps } = props;
  const classes = useStyles();
  const fieldKey = restProps['data-field-key'] as FieldsEnum;
  const {
    isFieldConfirmed,
    isFieldConfirmationRequired,
    onConfirmationChange,
  } = useCepikFormRowContainer(fieldKey, formName);
  const shouldShowFieldConfirmation =
    isFieldConfirmed || isFieldConfirmationRequired;

  return (
    <DefaultFormRowContainer
      {...props}
      className={classNames(className, classes.formRowContainer, {
        [classes.unconfirmed]: isFieldConfirmationRequired,
        [classes.raisedTooltip]: shouldShowFieldConfirmation,
        [classes.noPadding]: noPadding,
      })}
    >
      {shouldShowFieldConfirmation &&
        !fieldsWithoutConfirmationLabel.includes(fieldKey) && (
          <div className={classes.label}>
            <FormControlLabel
              className={cepikConfirmationLabelClassName}
              classes={{
                root: classes.formControlLabelRoot,
                label: classNames(classes.label, {
                  [classes.labelConfirmed]: isFieldConfirmed,
                }),
              }}
              checked={isFieldConfirmed}
              control={
                <Checkbox
                  className={classes.checkbox}
                  onChange={onConfirmationChange}
                  tabIndex={-1}
                />
              }
              label={CompareCepikDataEnum.Confirmed}
              labelPlacement="start"
            />
          </div>
        )}
      {children}
    </DefaultFormRowContainer>
  );
}
